import { createContext } from "react";

type SaveFn = (params?: {
  onSuccess?: () => void;
  onError?: () => void;
  additionalRequestData?: Record<string, any>;
}) => void;

export type FormApi = {
  refresh: (
    params?: { resetForm?: boolean; revalidateData?: boolean } | undefined,
  ) => Promise<void>;
  changeLanguage: (params: { lang: string; copy?: boolean }) => void;
  delete: () => void;
  save: SaveFn;
  hasUnsavedChanges: () => boolean;
};

export type ResourceFormApiContext = FormApi;

export const ResourceFormApiContext =
  createContext<ResourceFormApiContext | null>(null);
